import { match } from 'ts-pattern'

// 'pending' until the eligibility query resolves. Defaulting to a verdict while
// it loads would flash the wrong affordance, so callers render neither.
export type EligibilityVerdict = 'pending' | 'eligible' | 'ineligible'

export const toEligibilityVerdict = (
  data: { eligible: boolean } | null | undefined
): EligibilityVerdict =>
  match(data)
    .with(undefined, () => 'pending' as const)
    .with({ eligible: true }, () => 'eligible' as const)
    .otherwise(() => 'ineligible' as const)
